"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@chakra-ui/react");
var _react2 = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FileInfoBox = props => {
  const [details, setDetails] = (0, _react2.useState)(props.details);
  (0, _react2.useEffect)(() => {
    setDetails(props.details);
  }, [props.details]);
  const updateDetails = (key, value) => {
    const updatedDetails = {
      ...details,
      [key]: value
    };
    setDetails(updatedDetails);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Box, {
    borderWidth: "1px",
    w: 'xs',
    h: "100%",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
      m: 2,
      borderWidth: "1px",
      borderRadius: "lg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Center, {
        h: "200",
        children: [props.previewImageSrc && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Image, {
          src: props.previewImageSrc,
          objectFit: "contain",
          alt: "",
          h: "100%"
        }), props.previewElement]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Stack, {
      direction: "row",
      p: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {
        orientation: "vertical"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Table, {
        size: "sm",
        variant: "unstyled",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tbody, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "Name"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Editable, {
                placeholder: "Enter a name",
                onChange: nextValue => updateDetails('fileName', nextValue),
                onSubmit: () => props.onUpdate(details),
                value: details.fileName,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.EditableInput, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.EditablePreview, {})]
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "File type"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tag, {
                children: details.fileType
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "File size"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: details.fileSize || '-'
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "Created at"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: details.createdAt
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "Modified at"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: details.modifiedAt
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Stack, {
      direction: "row",
      p: 2,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Textarea, {
        onChange: e => updateDetails('description', e.target.value),
        onBlur: () => props.onUpdate(details),
        value: details.description ? details.description : 'Add a description'
      })
    })]
  });
};
var _default = FileInfoBox;
exports.default = _default;